'use strict';
require('../../modules/es.string.iterator');
require('../../modules/es.array.from');
var path = require('../../internals/path');

module.exports = path.Array.from;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/array/from.js
// module id = 1227
// module chunks = 0